module.exports = __webpack_public_path__ + "img/step4.6b275dfe.png";